import { InboxLayout } from '@/features/inbox/InboxLayout';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

// The list filters are named like the query parameters of GET /conversations (UI architecture §3.1).
export const Route = createFileRoute('/inbox')({
  staticData: { nav: 'inbox' },
  validateSearch: z.object({
    status: z.string().optional(),
    channel: z.string().optional(),
    assignee: z.string().optional(),
    search: z.string().optional(),
  }),
  component: InboxLayout,
});
